import { required, validEmail } from 'services/validators'

const customEvent = values => {
  const errors = {}
  if (!required(values.title)) {
    errors.title = 'Título requerido'
  }
  // Commented until BrokerValuationData have description too
  // if (!required(values.description)) {
  //   errors.description = 'Descripción requerida'
  // }
  const size = values.participants ? values.participants.length : 0

  if (
    required(values.participants) &&
    size > 0 &&
    values.participants[size - 1] &&
    !validEmail(values.participants[size - 1].value)
  ) {
    errors.participants = 'Error en uno de los email (ej. nombre@ejemplo.com)'
  }

  if (!required(values.date)) {
    errors.date = 'Fecha requerida'
  }
  if (!required(values.hours)) {
    errors.hours = 'Rango de horas requerido'
  }
  return errors
}

export default customEvent